import React from 'react';
import styles from './StepProgress.module.scss';

interface StepProgressProps {
  currentStep: number;
  totalSteps: number;
  hideLabel?: boolean;
  /** When true, only the current step dot is highlighted — past steps render as gray instead of complete. */
  highlightCurrentOnly?: boolean;
  /** Appended to the default "Step X of Y" label with a · separator. Lets a caller annotate the current step. */
  labelSuffix?: string;
  /** Replaces the default "Step X of Y" label entirely. Useful for terminal states like "Done". */
  labelOverride?: string;
}

export default function StepProgress({
  currentStep,
  totalSteps,
  hideLabel,
  highlightCurrentOnly,
  labelSuffix,
  labelOverride,
}: StepProgressProps) {
  return (
    <div className={styles.progress}>
      <div className={styles.dots}>
        {Array.from({ length: totalSteps }, (_, i) => {
          const step = i + 1;
          let stateClass = '';
          if (step < currentStep && !highlightCurrentOnly) {
            stateClass = styles.complete;
          } else if (step === currentStep) {
            stateClass = styles.active;
          }
          return <div key={step} className={`${styles.dot} ${stateClass}`} />;
        })}
      </div>
      {!hideLabel && (
        <div className={styles.label}>
          {labelOverride ?? (
            <>
              Step {currentStep} of {totalSteps}
              {labelSuffix ? ` · ${labelSuffix}` : ''}
            </>
          )}
        </div>
      )}
    </div>
  );
}
